import { render } from "./InvestEntrepreneurship.vue?vue&type=template&id=2b5eb2e0&scoped=true"
import script from "./InvestEntrepreneurship.vue?vue&type=script&lang=js"
export * from "./InvestEntrepreneurship.vue?vue&type=script&lang=js"

import "./InvestEntrepreneurship.vue?vue&type=style&index=0&id=2b5eb2e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b5eb2e0"

export default script